import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fahrer-list-view',
  imports: [],
  templateUrl: './fahrer.list-view.html',
  styleUrls: ['./fahrer.list-view.css'],
})
export class FahrerListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
